/* hubworker */
let WSHUB: WebSocket;
let T_ping: NodeJS.Timeout;
/*------------------------------------------------------------*/
self.onmessage = (e) => {
    const { head, data } = e.data;
    if (head == 'INIT') {
        wsHub(data);
    } else {
        if (WSHUB && WSHUB.readyState === WebSocket.OPEN) {
            WSHUB.send(JSON.stringify(e.data));
        }
    }
};
/*------------------------------------------------------------*/
const wsHub = (params: WSParams) => {
    const { url, app, uid, ver } = params;
    if (!url || !app || !uid || !ver) {
        console.error('[HubWorker] Invalid parameters');
        return;
    }
    const wsurl = `${url}?app=${app}&uid=${uid}&ver=${ver}`;
    // websocket
    WSHUB = new WebSocket(wsurl);
    WSHUB.onclose = () => {
        clearInterval(T_ping);
        self.postMessage({ head: 'DISCON' });
        setTimeout(() => wsHub(params), 1000 * 30);
    };
    WSHUB.onmessage = (e) => {
        try {
            const json = JSON.parse(e.data);
            const { head, data } = json;
            if (head == 'ACCEPT' && data) {
                startPing();
            }
            self.postMessage(json);
        } catch (err) {
            console.error('[HubWorker]', err);
        }
    };
};
/*------------------------------------------------------------*/
const startPing = () => {
    if (T_ping) clearInterval(T_ping);
    T_ping = setInterval(() => {
        if (WSHUB && WSHUB.readyState === WebSocket.OPEN) {
            WSHUB.send(JSON.stringify({ head: 'PING' }));
        }
    }, 1000 * 50);
};
/*------------------------------------------------------------*/
type WSParams = {
    url: string;
    app: string;
    uid: string;
    ver: string;
};